namespace GeniuzPOS.PosShift {
    export interface PsQueueForm {
        ShopId: Serenity.StringEditor;
        TodayDate: Serenity.StringEditor;
        LastQueueNo: Serenity.IntegerEditor;
    }

    export class PsQueueForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsQueue';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsQueueForm.init)  {
                PsQueueForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(PsQueueForm, [
                    'ShopId', w0,
                    'TodayDate', w0,
                    'LastQueueNo', w1
                ]);
            }
        }
    }
}
